export const SincronizacaoPropostasTipMessage =
  `O campo <strong>"horários para execução do processo"</strong> define o(s) horário(s) em que o processo será realizado automaticamente. Você deverá separar os horários por vírgulas.`
